import React, { useState, useEffect } from 'react';
import {
  Card, CardHeader, CardContent, List, TextField, Button, Stack, Box, Typography, Divider,
  Accordion, AccordionSummary, AccordionDetails,Snackbar, Alert
} from '@mui/material';
import TaskItem from './TaskItem';
import taskIcon from "../../assests/addTask.svg";
import { ArrowDownOutlined, CaretDownOutlined } from '@ant-design/icons';
import { TasksAPIService } from '../../services/api/TasksAPIService';
import { API_ERROR_MESSAGE, API_SUCCESS_MESSAGE } from '../../shared/constants';
import taskComplete from "../../assests/Images/joyStork.png";

const TaskCard = ({ title, data, type,phone }) => {
  const [tasks, setTasks] = useState(data?.tasks || []);
  const [newTask, setNewTask] = useState('');
  const [loading, setLoading] = useState(false);
  const [isAdding, setIsAdding] = useState(false);
  const [snackData, setSnackData] = useState({
        show: false,
        message: "",
        type: "error",
      });

  useEffect(() => {
    setTasks(type==="tasks" ? data?.tasks : data?.inquiries || []);
  }, [data]);

  const handleAddTask = () => {
    if (newTask.trim()) {
      let newTaskObj={}
      if(type === "tasks")
      {
       newTaskObj = {title: newTask, completed_at: false,due_by: null,phone:phone };
      }
      else
      {
        newTaskObj = {question: newTask, answer: null,phone:phone };
      }
      const payload = newTaskObj
      setLoading(true)
      TasksAPIService.taskCreation(payload,type==="tasks" ? "tasks" :"inquiries")
      .then((response) => {
        setSnackData({
          show: true,
          message:
           API_SUCCESS_MESSAGE.TASK_CREATED,
          type: "success",
        });

        setTasks([ response, ...tasks,]);
        setNewTask('');
        setIsAdding(false);
      })
      .catch((errResponse) => {
        setSnackData({
          show: true,
          message:
            API_ERROR_MESSAGE.INTERNAL_SERVER_ERROR,
          type: "error",
        });
      })
      .finally(() => setLoading(false));
    }
  };

  const handleDeleteTask = (id) => {
    setTasks(tasks.filter(t => t.id !== id));
    setLoading(true);
    TasksAPIService.taskDelete(id,type==="tasks" ? "tasks" :"inquiries")
      .then((response) => {
        setSnackData({
          show: true,
          message:
           API_SUCCESS_MESSAGE.TASK_DELETED,
          type: "success",
        });
      })
      .catch((errResponse) => {
        setSnackData({
          show: true,
          message:
            API_ERROR_MESSAGE.INTERNAL_SERVER_ERROR,
          type: "error",
        });
      })
      .finally(() => setLoading(false));

  };

  const getTaskById = (id) => {
    return tasks.find(t => t.id === id);
  };

  const handleDateChange = (id,date)=>{
    let taskToUpdate = getTaskById(id);

    setTasks(tasks.map(t =>
      t.id === id ? { ...t, due_by: date } : t
    ));
    taskToUpdate.due_by = date;

    updateTask(taskToUpdate,id,"update");
  }

  const handleToggleComplete = (id,e) => {
    let taskToUpdate = getTaskById(id);

    let operation = type === "tasks" ? e.target.checked ? "complete" : "incomplete" : "update";
    if(type !== "tasks")
    {
      taskToUpdate={...taskToUpdate,answer: e.target.checked ? new Date().toISOString() : null,completed_at: e.target.checked ? new Date().toISOString() : null};
      setTasks(tasks.map(t =>
        t.id === id
          ? { ...t, answer: t.answer ? null : new Date().toISOString() }
          : t
      ));
    }
    else{
      setTasks(tasks.map(t =>
        t.id === id
          ? { ...t, completed_at: t.completed_at ? null : new Date().toISOString() }
          : t
      ));
    }
    updateTask(taskToUpdate,id,operation);
  };

  const handleEditTask = (id, newText) => {
    let taskToUpdate = getTaskById(id);
    if(type === "tasks")
    {
      setTasks(tasks.map(t =>
        t.id === id ? { ...t, title: newText } : t
      ));
      taskToUpdate.title = newText;
    }
    else
    {
      setTasks(tasks.map(t =>
        t.id === id ? { ...t, question: newText } : t
      ));
      taskToUpdate.question = newText;
    }

    updateTask(taskToUpdate,id,"update");

  };


  const updateTask = (taskToUpdate,id,operation)=>{
    let payload =taskToUpdate;
    setLoading(true);
    TasksAPIService.taskEdit(payload,id,operation,type==="tasks" ? "tasks" :"inquiries")
      .then((response) => {
        setSnackData({
          show: true,
          message:
           API_SUCCESS_MESSAGE.TASK_UPDATED,
          type: "success",
        });
      })
      .catch((errResponse) => {
        setSnackData({
          show: true,
          message:
            API_ERROR_MESSAGE.INTERNAL_SERVER_ERROR,
          type: "error",
        });
      })
      .finally(() => setLoading(false));

  }

  const incompleteTasks = tasks?.filter(t => type === "tasks" ? !t.completed_at : !t.answer);
  const completedTasks = tasks?.filter(t => type === "tasks" ? t.completed_at : t.answer);

  return (
    <>
    <Card>
      <CardHeader title={<Typography variant="h6" sx={{ fontSize: "1.2rem" }}>
        {title}
      </Typography>} style={{padding:"16px 16px 0px 16px"}}/>
      <CardContent>

        {/* Add Task Section */}
        {isAdding ? (
          <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
            <TextField
              label={type==="tasks" ? "New Task" : "New Question"}
              value={newTask}
              onChange={(e) => setNewTask(e.target.value)}
              size="small"
              fullWidth
              onKeyDown={(e) => {
                if (e.key === 'Enter') handleAddTask();
              }}
            />
            <Button variant="contained" onClick={handleAddTask} disabled={loading}>
              Add
            </Button>
            <Button variant="outlined" onClick={() => setIsAdding(false)} disabled={loading}>
              Cancel
            </Button>
          </Stack>
        ) : (
          <Box sx={{ mb: 2 }}>
            <Button onClick={() => setIsAdding(true)} style={{ color: "#005CFF", textTransform: "none" }}>
              <img src={taskIcon} width="16px" style={{ marginRight: "10px" }} /> {type === "tasks" ? "Add a task" : "Add a question" }
            </Button>
          </Box>
        )}

        {/* Incomplete Tasks */}
        <Accordion defaultExpanded style={{ marginBottom: "10px", boxShadow: "1px 3px 10px #e6e6e6" }}>
          <AccordionSummary expandIcon={<CaretDownOutlined />}>
            <Typography variant="subtitle1">{type === "tasks" ? "Tasks" : "Questions"} ({incompleteTasks?.length})</Typography>
          </AccordionSummary>
          <AccordionDetails style={{ maxHeight: "300px",overflow: "hidden",overflowY: "scroll"}}>
            <List style={{ padding: "0px" }}>
              {incompleteTasks?.length > 0 ? (
                incompleteTasks.map(task => (
                  <TaskItem
                    key={task.id}
                    task={task}
                    onDelete={() => handleDeleteTask(task.id)}
                    onToggleComplete={handleToggleComplete}
                    // onEdit={(newText) => handleEditTask(task.id, newText)}
                    onEdit={handleEditTask}
                    onDateChange={handleDateChange}
                    type={type}
                  />
                ))
              ) :
              <>
                {completedTasks?.length > 0 ? (
                  <>
              <img src={taskComplete} style={{justifySelf:"center", width:"90px",display:"block", marginBottom:"10px"}}/>

                  <Typography sx={{ ml: 2,justifySelf:"center" }}> {type === "tasks" ? "All tasks completed" : "All questions completed"}</Typography>
                  <Typography variant="body2" sx={{ ml: 2,justifySelf:"center" }}> Nice work!</Typography>
                  </>
                )
                  :
                  (
                <Typography variant="body2" sx={{ ml: 2,justifySelf:"center" }}> {type === "tasks" ? "No tasks yet" : "No questions yet"}</Typography>
                  )
              }
                  </>
              }
            </List>
          </AccordionDetails>
        </Accordion>

        {/* Completed Tasks */}
        <Accordion style={{ marginBottom: "10px", boxShadow: "1px 3px 10px #e6e6e6" }}>
          <AccordionSummary expandIcon={<CaretDownOutlined />}>
            <Typography variant="subtitle1">Completed {type === "tasks" ? "Tasks" : "Questions"} ({completedTasks?.length})</Typography>
          </AccordionSummary>
          <AccordionDetails style={{ maxHeight: "300px",overflow: "hidden",overflowY: "scroll"}}>
            <List style={{ padding: "0px"}}>
              {completedTasks?.length > 0 ? (
                completedTasks.map(task => (
                  <TaskItem
                    key={task.id}
                    task={task}
                    onDelete={() => handleDeleteTask(task.id)}
                    onToggleComplete={handleToggleComplete}
                    onEdit={handleEditTask}
                    onDateChange={handleDateChange}
                    type={type}
                  />
                ))
              ) : (
                <Typography variant="body2" sx={{ ml: 2 ,justifySelf:"center"}}>No completed {type === "tasks" ? "tasks" : "questions"} yet.</Typography>
              )}
            </List>
          </AccordionDetails>
        </Accordion>

      </CardContent>
    </Card>

    <Snackbar
            style={{ top: "80px" }}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            open={snackData.show}
            autoHideDuration={3000}
            onClose={() => setSnackData({ show: false })}
          >
            <Alert
              onClose={() => setSnackData({ show: false })}
              severity={snackData.type}
            >
              {snackData.message}
            </Alert>
          </Snackbar>
          </>
  );
};

export default TaskCard;
